// extracted by mini-css-extract-plugin
export var boxItems = "_1o-1";
export var boxItemsLg = "_1o-2";
export var button = "_1o-7";
export var buttonLg = "_1o-8";
export var filterGroupBox = "_1o-0";
export var icon = "_1o-3";
export var iconSecondary = "_1o-6";
export var iconWrapper = "_1o-4";
export var iconWrapperLg = "_1o-5";